export default __webpack_public_path__ + "static/media/grupo_societario.3bf45c48.svg";